import { render, staticRenderFns } from "./PaintlistcreatePage.vue?vue&type=template&id=4fc3de82"
import script from "./PaintlistcreatePage.vue?vue&type=script&lang=js"
export * from "./PaintlistcreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports